import { prefixValue } from './_.utils';
import { omit } from 'ramda';
export var omitSpecialProperties = function (properties) {
    return omit([
        'order',
        'row',
        'alignV',
        'alignH',
        'fixed',
        'col',
        'colOffset',
        'hasMdCols',
        'fixedMd',
        'colMd',
        'colOffsetMd',
        'hasSmCols',
        'fixedSm',
        'colSm',
        'colOffsetSm',
        'hasXsCols',
        'fixedXs',
        'colXs',
        'colOffsetXs',
        'isExcludeForCalc',
        'isTranscludeForCalc',
        'isRequired',
        'activeIndex',
        'hasFract',
    ], properties);
};
export var mapElementClass = function (element) {
    var fixed = element.fixed, col = element.col, colOffset = element.colOffset, alignV = element.alignV, isRequired = element.isRequired;
    var colBase = fixed ? 'p-col-fixed' : !col ? 'p-col' : prefixValue(col, ' p-col-');
    colBase += prefixValue(colOffset, ' p-offset-');
    colBase += prefixValue(alignV, ' ');
    var cols = {
        colBase: colBase,
    };
    ['Md', 'Sm', 'Xs'].forEach(function (i) {
        if (element["has" + i + "Cols"]) {
            var partClassName = i.toLowerCase();
            var colValue = element["fixed" + i]
                ? "p-col-" + partClassName + "-fixed"
                : !element["col" + i]
                    ? "p-col-" + partClassName
                    : prefixValue(element["col" + i], " p-col-" + partClassName + "-");
            colValue += " p-col-offset-" + partClassName + "-" + (element["colOffset" + i] || 0);
            cols[i] = colValue;
        }
    });
    cols.required = isRequired ? 'required' : '';
    return Object.values(cols).join(' ');
};
export var findErrorField = function (elements, id) {
    var found;
    var iterate = function (arr) {
        if (!arr || found) {
            return;
        }
        arr.forEach(function (el) {
            // console.log('el_id in iterate: %s, id: %s', el.id, id);
            if (el.id === id) {
                found = true;
            }
            else {
                if (el.$type === 'block' && el.elements && el.elements.length) {
                    iterate(el.elements);
                }
            }
        });
    };
    iterate(elements);
    return found;
};
//# sourceMappingURL=element.utils.js.map